<template>
    <div class="flex align-center justify-between">
        <div>
            <h1 class="text-3xl font-semibold mb-1">Bulk Add/Edit Students</h1>
        </div>
    </div>
</template>

<script setup lang="ts">
</script>

<style scoped >
</style>